function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .ak {\n                fill: #0432e9;\n                opacity: 0;\n            }\n\n            .bk {\n                fill: none;\n                stroke: #000;\n                stroke-linecap: round;\n                stroke-linejoin: round;\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-316.7 -71.568)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "ak",
  width: 11.6,
  height: 11.6,
  transform: "translate(316.7 71.568)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(317.208 74)"
}, /*#__PURE__*/React.createElement("path", {
  className: "bk",
  d: "M27.368,10.5,24,12.906l3.368,2.406Z",
  transform: "translate(-16.783 -9.538)"
}), /*#__PURE__*/React.createElement("path", {
  className: "bk",
  d: "M2.462,7.5H7.755a.962.962,0,0,1,.962.962v4.811a.962.962,0,0,1-.962.962H2.462a.962.962,0,0,1-.962-.962V8.462A.962.962,0,0,1,2.462,7.5Z",
  transform: "translate(-1.5 -7.5)"
})));

function SvgVideoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.6,
    height: 11.6,
    viewBox: "0 0 11.6 11.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDark);
export default __webpack_public_path__ + "static/media/video_dark.4370bd55.svg";
export { ForwardRef as ReactComponent };